import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  fieldList: [],
  fieldCount: 1,
};

const templateSlice = createSlice({
  name: "template",
  initialState,
  reducers: {
    addToFieldList(state, action) {
      return {
        ...state,
        fieldList: [...state.fieldList, action.payload],
      };
    },
    setFieldList(state, action) {
      return {
        ...state,
        fieldList: action.payload,
      };
    },
    removeFromFieldList(state, action) {
      return {
        ...state,
        fieldList: state.fieldList.filter(
          (field) => field.id !== action.payload
        ),
      };
    },
    removePersistedFieldList(state, action) {
      return {
        ...state,
        fieldList: state.fieldList.filter(
          (field) => field.dyfId !== action.payload
        ),
      };
    },
    updateFieldList(state, action) {
      return {
        ...state,
        fieldList: state.fieldList.map(
          (field) => (field.id === action.payload.id ? action.payload : field) // if field.id === action.payload.id then return action.payload else return field
        ),
      };
    },
    updatePersistedFieldList(state, action) {
      return {
        ...state,
        fieldList: state.fieldList.map(
          (field) =>
            field.dyfId === action.payload.dyfId ? action.payload : field // if field.id === action.payload.id then return action.payload else return field
        ),
      };
    },
    clearFieldList(state) {
      return {
        ...state,
        fieldCount: 1,
        fieldList: [],
      };
    },
    incrementFieldCount(state) {
      return {
        ...state,
        fieldCount: state.fieldCount + 1,
      };
    },
    decrementFieldCount(state) {
      return {
        ...state,
        fieldCount: state.fieldCount - 1,
      };
    },
    deleteField(state, action) {
      // const currentSeqValue = params.data.dyfSeq;
      const currentValue = action.payload;
      const currentSeqValue = currentValue.dyfSeq;
      const currentFieldList = state.fieldList;
      let editedFieldList;

      //delete the row from the redux store
      if (currentValue.dyfId) {
        editedFieldList = currentFieldList.filter(
          (field) => field.dyfId !== currentValue.dyfId
        )
        
      } else {
        editedFieldList = currentFieldList.filter(
          (field) => field.id !== currentValue.id
        )
      }

      const newFieldList = editedFieldList
        ?.map((field) => {
          if (field.dyfSeq > currentSeqValue) {
            return {
              ...field,
              dyfSeq: field.dyfSeq - 1,
            };
          } else {
            return field;
          }
        })
        .sort((a, b) => a.dyfSeq - b.dyfSeq);

      return {
        ...state,
        fieldList: newFieldList,
      };
    },
    getHighestSeq(state) {
      const highestSeq = state.fieldList.reduce(
        (max, field) => Math.max(max, field.dyfSeq),
        0
      );
      return highestSeq;
    },
  },
});

export const templateActions = templateSlice.actions;
export default templateSlice;
